import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { getFilteredEvents } from '../../services/HandleFiltering';
import eventsToMap from '../../services/eventsToMap';
import { selectEvent } from '../../reducers/events';
import { updateBbox } from '../../reducers/bbox';
import { switchMapView } from '../../reducers/mapView';

import OskariMap from './OskariMap.jsx';
import MapEvents from '../eventDetails/MapEvents.jsx';

const mapStateToProps = state => ({
  events: eventsToMap(getFilteredEvents(state)),
  selectedEvent: state.events.selectedEvent,
  selectedBbox: state.bbox,
  mapView: state.mapView
});

const mapDispatchToProps = dispatch => ({
  select: eventId => dispatch(selectEvent(eventId)),
  selectBbox: bbox => dispatch(updateBbox(bbox)),
  changeMapView: (viewName, eventId) => dispatch(switchMapView(viewName, eventId))
});

const MapComponent = ({
  events,
  mapEvents,
  select,
  selectedEvent,
  selectBbox,
  selectedBbox,
  changeMapView,
  mapView
}) => (
  <Row>
    <Col md={12}>
      <div className="ibox">
        <div className="ibox-content map-ibox">
          <Row>
            <Col md={4}>
              <MapEvents
                mapEvents={mapEvents}
                selectedBbox={selectedBbox}
                changeMapView={changeMapView}
              />
            </Col>
            <Col md={8}>
              <OskariMap
                events={events}
                selectEvent={select}
                selectedEvent={selectedEvent}
                selectBbox={selectBbox}
                changeMapView={changeMapView}
                mapView={mapView}
              />
            </Col>
          </Row>
        </div>
      </div>
    </Col>
  </Row>
);

MapComponent.defaultProps = {
  selectedEvent: undefined
};

MapComponent.propTypes = {
  events: PropTypes.array.isRequired,
  mapEvents: PropTypes.array.isRequired,
  select: PropTypes.func.isRequired,
  selectedEvent: PropTypes.string,
  selectBbox: PropTypes.func.isRequired,
  selectedBbox: PropTypes.object.isRequired,
  changeMapView: PropTypes.func.isRequired,
  mapView: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(MapComponent);



// WEBPACK FOOTER //
// ./src/components/map/MapComponent.jsx